/*
 * @Description: 文章管理
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-04-16 13:18:16
 * @LastEditTime: 2019-04-23 16:02:21
 */

import React from 'react'
// @ts-ignore
import s from './style.css'

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { doChangeMongoArticle } from '../../controller';
import TimeInput from '../../components/TimeInput/TimeInput';

class Article extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      Id: '',
      value: '',
      Industry: '',
      platform: '',
      date: '',
      beginTime: '',
      endTime: '',
      enddate: '',
      emotion: '',
      originalEmotion: '',
      deleteArticle: ''
    }

    this.changeValue = this.changeValue.bind(this)
    this.changePlatform = this.changePlatform.bind(this)
    this.changeEmotion = this.changeEmotion.bind(this)
    this.changeBeginTime = this.changeBeginTime.bind(this)
    this.changeEndTime = this.changeEndTime.bind(this)
    this.changeOriginalEmotion = this.changeOriginalEmotion.bind(this)
    this.changeDeleteArticle = this.changeDeleteArticle.bind(this)
    this.changeLoveAll = this.changeLoveAll.bind(this)
    this.deleteArticle = this.deleteArticle.bind(this)
  }

  /**
   * 设置 value
   * @param {*} e 
   */
  changeValue (e) {
    this.setState({
      value: e.target.value
    })
  }

  /**
   * 设置 platform
   * @param {*} e 
   */
  changePlatform (e) {
    this.setState({
      platform: e.target.value
    })
  }

  /**
   * 设置 Emotion
   * @param {*} e 
   */
  changeEmotion (e) {
    this.setState({
      emotion: e.target.value
    })
  }
  changeOriginalEmotion (e) {
    this.setState({
      originalEmotion: e.target.value
    })
  }

  /**
   * 设置 beginTime
   * @param {String} val 
   */
  changeBeginTime (val) {
    this.setState({
      beginTime: val
    })
  }

  /**
   * 设置 endTime
   * @param {String} val 
   */
  changeEndTime (val) {
    this.setState({
      endTime: val
    })
  }

  /**
   * 设置 deleteArticle
   * @param {*} e 
   */
  changeDeleteArticle (e) {
    this.setState({
      deleteArticle: e.target.value
    })
  }

  /**
   * 批量修改好感度
   * @memberof Article
   */
  changeLoveAll () {
    const params = {
      brandName: this.state.value,
      platform: this.state.platform,
      startDate: this.state.beginTime,
      statisDate: this.state.endTime,
      key: 'updateEmotion',
      keyInfo: this.state.emotion,
      originalEmotion: this.state.originalEmotion
    }
    if (params.brandName == '') {
      alert("请填写品牌名称！")
    } else {
      doChangeMongoArticle(params)
        .then((res) => {
          if (res.errCode == 0) {
            alert("修改成功!")
            this.setState({
              value: ''
            })
          } else {
            alert("修改失败！")
          }
        })
    }
  }

  /**
   * 批量删除文章
   * @memberof Article
   */
  deleteArticle = () => {
    const params = {
      brandName: this.state.value,
      startDate: this.state.beginTime,
      statisDate: this.state.endTime,
      key: 'delete',
      keyInfo: this.state.deleteArticle,
      platform: this.state.platform
    }

    doChangeMongoArticle(params)
      .then(res => {
        if (res.errCode == 0) {
          alert("删除成功！")
        } else {
          alert("删除失败！")
        }
      })
  }

  render() {

    return (
      <div className={s.container}>
        <h1>文章管理</h1>

        {/* 批量删除 */}
        <fieldset>
          <legend>批量删除</legend>
          <form className={s.formWrapper}>
            <div>
              <label>品牌名称</label>
              <input type="text" value={this.state.value} placeholder="品牌名称" onChange={this.changeValue} />
            </div>
            <div>
              <label>开始时间</label>
              <TimeInput value={this.state.beginTime} placeholder="开始时间" onChange={this.changeBeginTime} />
            </div>
            <div>
              <label>结束时间</label>
              <TimeInput value={this.state.endTime} placeholder="开始时间" onChange={this.changeEndTime} />
            </div>
            <div>
              <label>选择平台</label>
              <select value={this.state.platform} onChange={this.changePlatform}>
                <option value="all">选择平台</option>
                <option value="wb">微博</option>
                <option value="wx">微信</option>
                <option value="zh" >知乎</option>
                <option value="tt">头条</option>
                <option value="wk">悟空问答</option>
              </select>
            </div>

            <div>
              <select value={this.state.deleteArticle} onChange={(e) => this.changeDeleteArticle(e)}>
                <option value='all'>所有文章</option>
                <option value='negative'>所有负面文章</option>
                <option value='-5'>反感</option>
                <option value='-3'>差评</option>
                <option value='1'>中立</option>
                <option value='3'>好评</option>
                <option value='5'>推荐</option>
              </select>
            </div>

            <div>
              <button type="button" onClick={this.deleteArticle}>批量删除</button>
            </div>

          </form>

        </fieldset>

        {/* 批量修改好感度 */}
        <fieldset>
          <legend>批量修改好感度</legend>
          <form className={s.formWrapper}>
            <div>
              <label>品牌名称</label>
              <input type="text" value={this.state.value} placeholder="品牌名称" onChange={this.changeValue} />
            </div>
            <div>
              <label>开始时间</label>
              <TimeInput value={this.state.beginTime} placeholder="开始时间" onChange={this.changeBeginTime} />
            </div>
            <div>
              <label>结束时间</label>
              <TimeInput value={this.state.endTime} placeholder="开始时间" onChange={this.changeEndTime} />
            </div>
            <div>
              <label>选择平台</label>
              <select value={this.state.platform} onChange={this.changePlatform}>
                <option value="all">选择平台</option>
                <option value="wb">微博</option>
                <option value="wx">微信</option>
                <option value="zh" >知乎</option>
                <option value="tt">头条</option>
                <option value="wk">悟空问答</option>
              </select>
            </div>

            <div>
              <label>原始好感度</label>
              <select value={this.state.originalEmotion} defaultValue="0" onChange={this.changeOriginalEmotion}>
                <option value="0" >选择</option>
                <option value="-5">反感</option>
                <option value="-3">差评</option>
                <option value="1">中立</option>
                <option value="3">好评</option>
                <option value="5">推荐</option>
              </select>
            </div>

            <div>
              <label>好感度修改成</label>
              <select value={this.state.emotion} defaultValue="0" onChange={this.changeEmotion}>
                <option value="0" >选择</option>
                <option value="-5">反感</option>
                <option value="-3">差评</option>
                <option value="1" >中立</option>
                <option value="3">好评</option>
                <option value="5">推荐</option>
              </select>
            </div>

            <div>
              <button type="button" onClick={this.changeLoveAll}>确认修改</button>
            </div>
          </form>
        </fieldset>
      </div>
    )
  }
}

export default withStyles(s)(Article);



// WEBPACK FOOTER //
// src/routes/cms/Article.js